module.exports = __webpack_public_path__ + "img/9.0b7ab54c.jpg";